import { withHydrate } from '@relay/react/hooks';
import { Device, from } from '@helpers/media';
import { isSSR } from '@helpers/ssr';
import withRedux from '@helpers/withRedux';
import useMedia from '@hooks/useMedia';
import useSeoText from '@hooks/useSeoText';
import CarouselProvider from '@stories/Components/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Carousel/Connected/Connected';
import ProductList from '@stories/Components/Products/ProductList/ProductList.hybrid';
import { ProductListingFiltersStyles } from '@stories/Components/Products/ProductListingFilters/ProductListingFilters.styles';
import CarouselButton from '@stories/Elements/Media/CarouselButton/CarouselButton';
import { Column } from '@stories/Settings/Grids/Grid.styles';
import WhatsNewBanner from '@stories/Widgets/Banners/WhatsNewBanner/WhatsNewBanner.hybrid';
import { MotionConfig } from 'framer-motion';
import React, { useRef, useState } from 'react';
import { Route, BrowserRouter as Router, StaticRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import ProductListHeader from '../ProductListHeader/ProductListHeader';
import { ProductListingStyles } from '../ProductListing/ProductListing.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const TradesProductListing = props => {
  const fullTextRef = useRef(null);
  const [childCategories, setChildCategories] = React.useState();
  const [banner, setBanner] = useState(props.banner);
  const {
    text: truncatedSubtitle,
    hasTruncated: showReadMore
  } = useSeoText(props.category?.description);
  const slidesToShow = useMedia([from(Device.DesktopSmall), from(Device.TabletLarge), from(Device.Tablet)], [10, 6, 5], 3);
  const children = /*#__PURE__*/_jsx(QueryParamProvider, {
    ReactRouterRoute: Route,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [props.showBanner && banner && /*#__PURE__*/_jsx(WhatsNewBanner, {
        ...banner
      }), props.category ? /*#__PURE__*/_jsx(ProductListHeader, {
        inView: true,
        title: props.category.title,
        titleLogo: props.category.logo,
        description: truncatedSubtitle,
        backText: props.category.backText,
        backUrl: props.category.backUrl,
        background: "white",
        showReadMore: showReadMore,
        readMoreText: props.translations['custom.read-more'],
        readMoreOnClick: () => {
          if (fullTextRef.current) {
            fullTextRef.current.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }
      }) : null, childCategories && /*#__PURE__*/_jsx(ProductListingStyles.CategoryFiltersWrapper, {
        children: /*#__PURE__*/_jsx(Column.Full, {
          children: /*#__PURE__*/_jsx(MotionConfig, {
            transition: {
              duration: 0.45,
              ease: 'easeOut'
            },
            children: /*#__PURE__*/_jsx(CarouselProvider, {
              count: childCategories.filterOptions.length,
              paddingOffset: 0,
              pageChildren: 1,
              children: /*#__PURE__*/_jsx(Connected, {
                children: carousel => /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(ProductListingStyles.CategoryFilters, {
                    children: /*#__PURE__*/_jsx(ProductListingStyles.Track, {
                      "data-center": childCategories.filterOptions.length > slidesToShow,
                      trackMutations: true,
                      enableCarousel: true,
                      children: childCategories.filterOptions.map(category => /*#__PURE__*/_jsx(ProductListingStyles.CategoryFilterItemWrapper, {
                        onClick: () => {
                          window.location.href = category.value;
                        },
                        children: /*#__PURE__*/_jsxs(ProductListingStyles.CategoryFilterItem, {
                          href: category.value,
                          children: [/*#__PURE__*/_jsx(ProductListingStyles.CategoryFilterItemImageContainer, {
                            children: /*#__PURE__*/_jsx(ProductListingStyles.CategoryFilterItemImage, {
                              src: category.listingImage,
                              role: "presentation"
                            })
                          }), /*#__PURE__*/_jsx(ProductListingStyles.CategoryFilterItemTitle, {
                            children: category.name
                          })]
                        })
                      }, category.name))
                    })
                  }), childCategories.filterOptions.length > slidesToShow && /*#__PURE__*/_jsxs(ProductListingStyles.ControlsContainer, {
                    children: [/*#__PURE__*/_jsx(ProductListingStyles.LineContainer, {
                      progress: (carousel.activeIndex + slidesToShow) / childCategories.filterOptions.length * 100
                    }), /*#__PURE__*/_jsxs(ProductListingStyles.Controls, {
                      children: [/*#__PURE__*/_jsx(CarouselButton, {
                        direction: "left",
                        disabled: carousel.activeIndex === 0,
                        theme: "red",
                        hideLine: true,
                        onClick: event => {
                          event.preventDefault();
                          carousel?.goToPrev();
                        }
                      }), /*#__PURE__*/_jsx(CarouselButton, {
                        direction: "right",
                        theme: "red",
                        hideLine: true,
                        disabled: carousel.activeIndex + slidesToShow >= childCategories.filterOptions?.length,
                        onClick: event => {
                          event.preventDefault();
                          carousel?.goToNext();
                        }
                      })]
                    })]
                  })]
                })
              })
            })
          })
        })
      }), /*#__PURE__*/_jsxs(ProductListingStyles.Wrapper, {
        children: [/*#__PURE__*/_jsx(ProductListingFiltersStyles.FiltersElement, {
          "data-filters-bar": "true"
        }), /*#__PURE__*/_jsx(ProductList, {
          ...props,
          showCards: false,
          productListGuids: null,
          productListGuid: null,
          groupByCategory: false,
          includeAllCategories: true,
          tradeAgilityId: props.tradeAgilityId,
          promoCards: [],
          setTradeBanner: setBanner,
          setChildCategories: setChildCategories
        }), showReadMore && props.category?.description && /*#__PURE__*/_jsx(ProductListingStyles.FooterDescriptionContainer, {
          children: /*#__PURE__*/_jsx(ProductListingStyles.FooterDescriptionInner, {
            children: /*#__PURE__*/_jsx(ProductListingStyles.FooterDescription, {
              ref: fullTextRef,
              dangerouslySetInnerHTML: {
                __html: props.category?.description
              }
            })
          })
        })]
      })]
    })
  });
  if (isSSR) {
    return /*#__PURE__*/_jsx(StaticRouter, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Router, {
    children: children
  });
};
export default withHydrate(withRedux(TradesProductListing), 'TradesProductListing', 'hybrid');
